import {
  traceInformation,
  traceWarning,
  traceError,
  tag,
} from "@unu/ui-insights";

export const useInsights = () => {

  return {
    traceInformation,
    traceWarning,
    traceError,
    tag,
  };
};
